import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function IdentificationSection() {
  return <section className="py-20 px-4 bg-white relative" data-id="element-179">
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-180">
        <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-181">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#F6F1E9" data-id="element-182"></path>
        </svg>
      </div>

      <div className="max-w-3xl mx-auto pt-10" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-184">
          <h2 className="font-display font-bold text-2xl sm:text-3xl md:text-4xl text-teal mb-6 leading-tight break-words" data-id="element-185">
            ¿Y si el problema no es que estés rota…{' '}
            <br className="hidden md:block" data-id="element-186" />
            <span className="italic font-medium text-sage-dark" data-id="element-187">
              sino que tu cuerpo aprendió a vivir en alerta?
            </span>
          </h2>
        </motion.div>

        <div className="space-y-5 sm:space-y-6 text-base sm:text-lg text-neutral-gray leading-relaxed mb-12 font-sans" data-id="element-188">
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-189">
            <span className="font-bold text-teal" data-id="element-190">
              El agotamiento que no desaparece aunque duermas.
            </span>{' '}
            Te despiertas cansada, sintiendo una tensión constante en el pecho o
            los hombros, como si estuvieras esperando que algo malo sucediera.
          </motion.p>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-191">
            <span className="font-bold text-teal" data-id="element-192">
              La ansiedad que aparece sin razón aparente.
            </span>{' '}
            Has intentado meditar, tomar suplementos o simplemente "relajarte",
            pero tu mente no se apaga. Esa sensación de desconexión profunda te
            hace sentir que estás perdiendo el control de tus propias emociones.
          </motion.p>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-193">
            <span className="font-bold text-teal" data-id="element-194">
              Las soluciones que prometían mucho y cumplieron poco.
            </span>{' '}
            Has probado de todo, pero nada parece tocar la raíz del problema.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-16" data-id="element-195">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50/50 rounded-2xl p-6 border border-urgency/20" data-id="element-196">
            <ul className="space-y-4" data-id="element-197">
              {['Despertarte cansada aunque hayas dormido 8 horas', 'Sentir que tu cuerpo reacciona exagerado ante cualquier cosa', 'Irritarte sin querer y luego sentirte culpable', 'Intentar de todo y seguir igual'].map((item, i) => <li key={i} className="flex items-start text-neutral-gray text-sm md:text-base" data-id="element-198">
                  <XCircle className="mr-3 text-urgency shrink-0 mt-0.5" size={20} data-id="element-199" />
                  <span data-id="element-200">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-50/50 rounded-2xl p-6 border border-relief/20" data-id="element-201">
            <ul className="space-y-4" data-id="element-202">
              {['Existe una razón fisiológica para lo que sientes', 'Tu sistema nervioso puede ser re-entrenado', 'No necesitas más fuerza de voluntad. Necesitas el método correcto.'].map((item, i) => <li key={i} className="flex items-start text-neutral-gray text-sm md:text-base" data-id="element-203">
                  <CheckCircle2 className="mr-3 text-relief shrink-0 mt-0.5" size={20} data-id="element-204" />
                  <span data-id="element-205">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}